module.exports = __webpack_public_path__ + "img/1716365339883-WhatsApp Image 2024-05-22 at 14.10.12.jpeg.0f896ac0.webp";